import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DOMPurify from "dompurify";
import {
    getConfigButton,
    getConfigHeader,
    getConfigHeaderMessage,
    getMediaSize,
} from "../../store/configSlice";
import {
    setFilterClosing,
    setFilterOpened,
    getFilterOpened,
    getFilterClosing,
} from "../../store/filterSlice";
import Clock from "./../Clock";
import style from "./Header.module.scss";
import { MEDIA_SIZES } from "../../util/useMediaQuery";
import HorLine from "./hor-line.svg";

const HeaderBody = ({
    header,
    headerMessage,
    mediaSize,
    setFilterOpened,
    setFilterClosing,
    filterOpened,
    filterClosing,
    buttonConfig,
}) => {
    useEffect(() => {
        document.title = header.pageTitle;
    }, [header]);

    const openCallback = useCallback(() => {
        setFilterOpened(true);
        // Для предотвращение мерцания когда уже не opened, но еще не closing
        setFilterClosing(true);
    }, [setFilterOpened]);

    const closeCallback = useCallback(() => {
        setFilterOpened(false);
        setFilterClosing(true);

        setTimeout(() => {
            setFilterClosing(false);
        }, 300);
    }, [setFilterOpened, setFilterClosing]);

    return (
        <>
            <h1 className={style.wrapper} style={header?.style}>
                <button
                    type="button"
                    onClick={filterOpened ? closeCallback : openCallback}
                    title="Открыть меню"
                    className={
                        mediaSize !== MEDIA_SIZES.smartphone
                            ? style.button
                            : style.button_mobile
                    }
                    style={
                        mediaSize !== MEDIA_SIZES.smartphone
                            ? buttonConfig?.style
                            : buttonConfig?.styleMobile
                    }
                >
                    <img
                        src={HorLine}
                        className={style.butonInnerLine}
                        alt=""
                    />
                    <img
                        src={HorLine}
                        className={style.butonInnerLine}
                        alt=""
                    />
                    <img
                        src={HorLine}
                        className={style.butonInnerLine}
                        alt=""
                    />
                </button>
                    {/* <div className={style.logo}/> */}
                <div
                    className={style.titleStyle}
                    style={header?.titleStyle}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(header.titleText),
                    }}
                />
                <Clock />
            </h1>
            {!!headerMessage && headerMessage?.text?.length ? (
                <h2
                    className={style.message}
                    style={headerMessage?.style}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(headerMessage.text),
                    }}
                />
            ) : null}
        </>
    );
};

HeaderBody.propTypes = {
    header: PropTypes.object.isRequired,
};

const Header = connect(
    (state) => ({
        header: getConfigHeader(state),
        headerMessage: getConfigHeaderMessage(state),
        mediaSize: getMediaSize(state),
        filterOpened: getFilterOpened(state),
        filterClosing: getFilterClosing(state),
        buttonConfig: getConfigButton(state),
    }),
    {
        setFilterClosing,
        setFilterOpened,
    }
)(HeaderBody);

Header.propTypes = {};

export { Header };
